var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-dropdown-box" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "tit" }, [
        _vm._v(_vm._s(_vm.$t("PCOP-02-02-04-13") /*결재 상태*/))
      ]),
      _c("i", {
        staticClass: "icon icon-dropdown-m-arrow",
        class: { rotate: !_vm.show3 },
        on: {
          click: function($event) {
            _vm.show3 = !_vm.show3
          }
        }
      })
    ]),
    _vm.show3
      ? _c("div", { staticClass: "content" }, [
          _c(
            "dl",
            { staticClass: "dlist dlist-item--type4" },
            [
              _c("dt", [
                _vm._v(_vm._s(_vm.$t("PCOP-02-02-04-13") /*결재 상태*/))
              ]),
              _c("dd", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.RCA040DA40Response.lastPrcssStusDstcd +
                        "_결재처리상태구분코드"
                    )
                  )
                )
              ]),
              !_vm._.isEmpty(_vm.RCA040DA40Response.errMsgCtnt)
                ? [
                    _c("dt", [
                      _vm._v(_vm._s(/*취소사유*/ _vm.$t("PCOP-02-02-04-16")))
                    ]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.RCA040DA40Response.errMsgCtnt))
                    ])
                  ]
                : _vm._e(),
              _vm.RCA040DA40Response.lastPrcssStusDstcd != 20
                ? [
                    _c("dt", [
                      _vm._v(_vm._s(/*반송사유*/ _vm.$t("PCOP-02-02-04-17")))
                    ]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.RCA040DA40Response.trsaccSndbakResnCtnt)
                      )
                    ])
                  ]
                : _vm._e(),
              _c("dt", [
                _vm._v(_vm._s(_vm.$t("PCOP-02-02-04-14") /*처리 상태*/))
              ]),
              _c(
                "dd",
                [
                  _vm.RCA040DA40Response.lastPrcssStusDstcd == "20" &&
                  _vm.RCA040DA40Response.iBTelgmPrcssRsultCd != ""
                    ? [
                        _vm.RCA040DA40Response.corpBzwkCd ==
                        _vm.$config.CORP_BZWK_APRVALCD_110081
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "0|1|2|3|4|5|9|A".includes(
                                      _vm.RBF1605T41Response
                                        .untcTrsaccPrgrsDstcd
                                    )
                                      ? _vm.$t(
                                          _vm.RBF1605T41Response
                                            .untcTrsaccPrgrsDstcd + "_otrQtStat"
                                        )
                                      : ""
                                  ) +
                                  " "
                              )
                            ]
                          : (_vm.RCA040DA40Response.corpBzwkCd ==
                              this.$config.CORP_BZWK_APRVALCD_110011 ||
                              _vm.RCA040DA40Response.corpBzwkCd ==
                                this.$config.CORP_BZWK_APRVALCD_110012) &&
                            _vm.RCA040DA40Response.iBTelgmPrcssRsultCd == "0000"
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    /*PhoneTopup과 Bill Payment는 상태값 2 3 9 B(기타) 만 사용*/ "2|3|9".includes(
                                      _vm.RBF1605T41Response
                                        .untcTrsaccPrgrsDstcd
                                    )
                                      ? _vm.$t(
                                          _vm.RBF1605T41Response
                                            .untcTrsaccPrgrsDstcd + "_otrQtStat"
                                        )
                                      : ""
                                  ) +
                                  " "
                              )
                            ]
                          : [
                              _vm.RCA040DA40Response.iBTelgmPrcssRsultCd ==
                              "0000"
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        /*정상*/ _vm.$t("PCOP-02-02-04-15")
                                      )
                                    )
                                  ]
                                : [
                                    _vm.RCA040DA40Response.corpBzwkCd ==
                                    this.$config.CORP_BZWK_APRVALCD_110082
                                      ? _c(
                                          "div",
                                          { staticClass: "state warning" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  /*오류*/ _vm.$t(
                                                    "PCOP-02-03-03-18"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.RCA040FA40Response
                                                    .dataGrid[0].errMsg
                                                    ? "(" +
                                                        _vm.RCA040FA40Response
                                                          .dataGrid[0].errMsg +
                                                        ")"
                                                    : ""
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "state warning" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                /*오류*/ _vm.$t(
                                                  "PCOP-02-03-03-18"
                                                )
                                              ) +
                                                _vm._s(
                                                  _vm.RCA040DA40Response.errMsg
                                                    ? "(" +
                                                        _vm.RCA040DA40Response
                                                          .errMsg +
                                                        ")"
                                                    : ""
                                                )
                                            )
                                          ]
                                        )
                                  ]
                            ]
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c("dt", [
                _vm._v(_vm._s(/*최종 완료일시*/ _vm.$t("PCOP-02-02-04-18")))
              ]),
              _c("dd", [
                _vm._v(
                  _vm._s(
                    _vm.RCA040DA40Response.prcssFnshYMS &&
                      _vm.$getGlobalDateFmt(
                        this._.padEnd(
                          _vm.RCA040DA40Response.prcssFnshYMS,
                          20,
                          " "
                        )
                      )
                  )
                )
              ])
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }